// store/index.js

import Vue from "vue";
import Vuex from "vuex";
import VuexPersist from 'vuex-persist';

Vue.use(Vuex);

const step = {
    steps: [
        {
            name: "data",
            hasError: false,
            complete: false,
        },
        {
            name: "datetime",
            hasError: false,
            complete: false,
        },
        {
            name: "cofirm",
            hasError: false,
            complete: false,
        }
    ],
    activeStep: 0
}

const event = {
    _id: "",
    start: "",
    classNames: "reserved",
    patient: {},
    covenant: "",
    procedure: {},
    //telemedicine: { type: Boolean, default: false },
    //agent: "",
    doctor: "",
    office: "",
    //clinic: "",
};

// root state object.
// each Vuex instance is just a single state tree.
const state = {
    partner: {},
    step,
    verifiedPhones: {},
    event,
    loading: false,
}

// mutations are operations that actually mutate the state.
// each mutation handler gets the entire state tree as the
// first argument, followed by additional payload arguments.
// mutations must be synchronous and can be recorded by plugins
// for debugging purposes.
const mutations = {

    partner(state, value = {}) {
        state.partner = value;
    },

    step(state, value = step) {
        state.step.steps[state.step.activeStep] = Object.assign({}, state.step.steps[state.step.activeStep], value);
    },
    activeStep(state, value = 0) {
        state.step.activeStep = value
    },

    verifiedPhones(state, value) {
        const phoneNumber = value.phoneNumber.replace(/\D/g, '');
        if (!state.verifiedPhones[phoneNumber]) state.verifiedPhones[phoneNumber] = {};
        if (value.sendTime) state.verifiedPhones[phoneNumber].sendTime = value.sendTime;
        state.verifiedPhones[phoneNumber].checked = value.checked == true;
    },

    // verifiedPhones(state, phoneNumber) {
    //     phoneNumber = phoneNumber.replace(/\D/g, '');
    //     state.verifiedPhones[phoneNumber] = true;
    // },

    event(state, value) {
        if (!value) {
            value = {
                _id: "",
                start: "",
                classNames: "reserved",
                patient: {},
                covenant: "",
                procedure: {},
                //telemedicine: { type: Boolean, default: false },
                //agent: "",
                track: ""
            };
            //state.event = Object.assign({}, state.event, value);
        } //else {
        state.event = Object.assign({}, state.event, value);
        //}
    },

    loading(state, value = true) {
        state.loading = value;
    },
}

const getters = {
    partner: state => state.partner,
    step: state => state.step,
    verifiedPhones: state => state.verifiedPhones,
    event: state => state.event,
    loading: state => state.loading,
}

const vuexLocal = new VuexPersist({
    storage: window.localStorage,
    reducer: state => ({
        //step: state.step,
        partner: state.partner,
        event: state.event,
        verifiedPhones: state.verifiedPhones
    })
})


export default new Vuex.Store({
    state,
    getters,
    mutations,
    //actions
    plugins: [vuexLocal.plugin]
});